import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

import { IgDialog } from "@intelligems/ig-theme/IgDialog";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { useRefreshShopifyScopes } from "@src/api/user-auths/login";
import { useDialog, useDialogs } from "@src/hooks/dialog";
import { GENERAL_ROUTES } from "@src/routes/routes";
import { useDispatch, useSelector } from "@src/store";
import { snoozeShopifyScopesDialog } from "@src/store/slices/appSettings";

export const MissingShopifyScopeDialog: FC = () => {
  const dispatch = useDispatch();
  const snoozedShopifyScopesDialog = useSelector(
    (state) => state.appSettings.snoozeShopifyScopesDialog
  );
  const dialog = useDialog("missingShopifyScope");
  const { isDialogOpen } = useDialogs();

  const navigate = useNavigate();

  // New users may see both of these, hide the shopify scope dialog if onboarding is also open
  const isOpen = dialog.isOpen && !isDialogOpen("onboarding");

  useGetOrg({
    refetchOnMount: isOpen ? "always" : undefined,
    refetchOnWindowFocus: isOpen ? "always" : undefined,
  });

  const refreshShopifyCredentials = useRefreshShopifyScopes();

  const handleClose = (reason: string) => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      if (!snoozedShopifyScopesDialog) {
        dispatch(snoozeShopifyScopesDialog());
      }
    } else {
      void navigate(GENERAL_ROUTES.Index);
    }
    dialog.close();
  };
  const handleYesClick = () => {
    refreshShopifyCredentials.mutate({});
  };

  return (
    <IgDialog
      handleClose={handleClose}
      rawContent={
        dialog.props?.initial
          ? "Please reauthorize your store to access all latest features."
          : "This feature requires additional permissions from Shopify. Please reauthorize your store to continue."
      }
      shouldNotClose={true}
      loading={refreshShopifyCredentials.isPending}
      handleYesClick={handleYesClick}
      yesButtonText={"Update Permissions"}
      noButtonText={null}
      title={"Update Shopify Permissions"}
      showDialog={isOpen}
      dialogHeight={null}
      hideActions={false}
    />
  );
};
